import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { AutocompleteComponent } from 'app/shared/components/atoms/autocomplete/autocomplete.component';
import { distinctUntilChanged, filter, Observable } from 'rxjs';

@Component({
  selector: 'app-mat-select-cell-renderer',
  templateUrl: './mat-select-cell-renderer.component.html',
  imports: [
    CommonModule,
    TranslateModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    AutocompleteComponent,
  ],
})
export class MatSelectCellRendererComponent implements ICellRendererAngularComp {
  public selectedValue!: string;
  public menuOptions = [];
  public filteredOptions!: Observable<string[]>;
  public params!: ICellRendererParams;
  public placeholder = 'All groups';
  public allowNew = false;
  public form!: FormGroup;
  private readonly destroyRef = inject(DestroyRef);

  public agInit(params: ICellRendererParams): void {
    this.initializeParams(params);
  }

  public refresh(params: ICellRendererParams): boolean {
    this.initializeParams(params);
    return true;
  }

  private initializeParams(params: ICellRendererParams): void {
    this.params = params;
    this.form = new FormGroup({
      inputControl: new FormControl(params.value),
    });
    const arrayKey = Object.keys(params.data).find((key) => Array.isArray(params.data[key]));

    if (arrayKey) {
      this.menuOptions = params.data[arrayKey];
    } else {
      console.error('No array found in params.data for dropdown options.');
      this.menuOptions = [];
    }

    this.placeholder = params.colDef?.cellRendererParams?.placeholder || this.placeholder;
    this.form
      .get('inputControl')
      ?.valueChanges.pipe(
        takeUntilDestroyed(this.destroyRef),
        filter((value) => value !== params.value),
        distinctUntilChanged(),
      )
      .subscribe((value) => {
        this.onSelectionChange(value);
      });
  }

  public onSelectionChange(value: string): void {
    if (this.params.context?.componentParent) {
      this.params.context.componentParent.onSelectionChange(this.params.data.driverId, value);
    } else {
      console.error('Parent component context is not available.');
    }
  }
}
